<template>
    <div class="special-service" @touchmove.prevent>
        <div class="service-info">
            <div class="mask" v-if="isSuccess">
                <div class="success-info">
                    <img class="success-bg" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/success-bg.png">
                    <div class="tip-box">
                        <p class="info">老师，您好:<br>您的预约我们已经收到，请保持手机畅通，我们将在3天内安排专业顾问与您联系</p>
                        <button class="confirm-btn" @click="handleHide">确定</button>
                    </div>
                </div>
            </div>
            <img class="close-btn" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/icon-close.png" @click="handleHide">
            <p class="service-title">预约专业顾问咨询</p>

            <el-form ref="form" :model="form" :rules="rules" label-width="135px" label-position="top" hide-required-asterisk>
              <div class="form-inner">
                <el-form-item label="联系人姓名" prop="name">
                  <el-input v-model.trim="form.name" :maxlength="99" placeholder="请输入您的姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="tel">
                  <el-input v-model.trim="form.tel" :maxlength="99" placeholder="请输入您的联系电话"></el-input>
                </el-form-item>
                <el-form-item label="机构名称" prop="school_name">
                  <el-input v-model.trim="form.school_name" :maxlength="99" placeholder="请输入您的机构名称"></el-input>
                </el-form-item>
                <el-form-item label="机构地址" prop="area_id">
                  <AreaCascader v-model="form.area_id" />
                </el-form-item>
              </div>
              <div class="form-other">
                <el-form-item label="选择您有意向的项目" prop="cooperations">
                  <el-radio-group v-model="form.cooperations">
                    <el-radio :label="1">双师</el-radio>
                    <el-radio :label="2">AI</el-radio>
                    <el-radio :label="3">未来好课</el-radio>
                    <el-radio :label="libuID">励步</el-radio>
                    <el-radio :label="24">教研云</el-radio>
                    <el-radio :label="25">魔法学习机</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="您的机构是否具备从事学科培训业务的资格（营业执照/民办非企业单位登记证书和办学许可）" prop="permission">
                  <el-radio-group v-model="form.permission">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                    <el-radio :label="3">办理中，半年内可获得</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                   <el-input type="textarea" v-model="form.description" :rows="4" placeholder="问题简述：可以简单描述下您机构当前遇到的问题"></el-input>
                </el-form-item>
              </div>
            </el-form>

            <button class="submit-btn" @click="handleSubmit">完成并预约</button>
        </div>
    </div>
</template>
<script>
import authApi from '@/services/interface'
import AreaCascader from '@/components/areaCascader'
export default {
  components: {
    AreaCascader
  },
  data () {
    const validatePhone = (rule, value, callback) => {
      let str = value.replace(/\s*/g, '')
      let reg = /^1[0-9]{10}$/
      const result = reg.test(str)
      if (!result) {
        callback(new Error('您输入的手机号码有误，请检查后重新输入'))
      } else {
        callback()
      }
    }
    return {
      isSuccess: false,
      form: {
        name: '',
        tel: '',
        school_name: '',
        area_id: '',
        cooperations: '',
        permission: '',
        description: '',
        equipment_type: this.$store.getters.isPC ? 1 : 2,
        qualification: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        school_name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        area_id: [
          { required: true, message: '请选择地区', trigger: 'change' }
        ],
        cooperations: [
          { required: true, message: '请选择有意向的项目', trigger: 'change' }
        ],
        permission: [
          { required: true, message: '请选择从事资格', trigger: 'change' }
        ]
      },
      libuID: process.env.NODE_ENV === 'production' ? '22' : '22'
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitData()
        } else {
          this.$message({
            type: 'error',
            message: '表单填写有误，请检查后重新输入'
          })
          return false
        }
      })
    },
    submitData () {
      authApi.newRegister(this.form).then(res => {
        if (res.ok) {
          this.isSuccess = true
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    handleHide () {
      this.$emit('hide')
    }
  }
}
</script>
<style lang="scss" scoped>
.special-service{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.4);
    z-index: 1500;
    overflow-y: auto;
    .service-info{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #ffffff;
        margin-top: 70px;
        margin-bottom: 10px;
        padding: 34px 28px 30px;
        border-radius:12px;
        text-align: left;
        .mask{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 8001;
            background: rgba(0,0,0,0.4);
            .success-info{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width:560px;
                height:460px;
                background:#ffffff;
                border-radius:12px;
                .success-bg{
                    width: 560px;
                    height: 247px;
                }
                .tip-box{
                    padding: 27px 74px 37px 68px;
                    .info{
                        font-family: PingFangSC-Light;
                        font-size:17px;
                        font-weight:300;
                        color: #000000;
                        line-height: 25px;
                    }
                    .confirm-btn{
                        width: 400px;
                        display: block;
                        margin: 25px auto 0px;
                        height:50px;
                        border: none;
                        background:#FB594A;
                        box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.08);
                        border-radius:4px;
                        font-size:22px;
                        font-family:PingFangSC-Regular;
                        color:#ffffff;
                        cursor: pointer;
                    }
                }
            }
        }
        .close-btn{
            position: absolute;
            width: 15px;
            height: 15px;
            top: 30px;
            right: 30px;
            cursor: pointer;
        }
        .service-title{
          font-size:24px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(0,0,0,1);
          line-height:50px;
          text-align: center;
        }
        .submit-btn{
            display: block;
            margin: 30px auto 0px;
            width:400px;
            height:50px;
            border: 0;
            outline: none;
            background:#FB594A;
            box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.08);
            border-radius:4px;
            font-size:20px;
            font-family:PingFangSC-Regular;
            color: #ffffff;
            cursor: pointer;
        }
    }
    .form-inner {
      display: flex;
      flex-wrap: wrap;
      width: 620px;
      justify-content: space-between;
      /deep/ .el-form-item {
        margin-right: 12px;
        width: 294px;
        &:nth-child(2n) {
          margin-right: 0px;
        }
      }
      /deep/ .el-form-item__label {
        margin-left: 10px;
        margin-bottom: 0px;
        padding-bottom: 0px;
        color: #000000;
      }
      /deep/ .el-cascader {
        width: 100%;
      }
      // /deep/ .el-input__inner:focus {
      //   border-color: #FB5A4A;
      // }
    }
    .form-other {
      /deep/ .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        max-width: 620px;
        justify-content: start;
      }
      /deep/ .el-radio {
          min-width: 80px;
          margin-right: 70px;
          margin-bottom: 12px;
        }
      /deep/ .el-form-item__label {
        margin-bottom: 0px;
        padding-bottom: 0px;
        color: #ACACAC;
      }
      /deep/ .el-radio__input.is-checked+.el-radio__label {
        color: #606266;
      }
      /deep/ .el-radio__inner {
        width: 18px;
        height: 18px;
      }
      /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: #DCDFE6;
        background: #fff;
        &::after {
          width: 8px;
          height: 8px;
          background-color: #409EFF;
        }
      }
      // /deep/ .el-textarea__inner:focus {
      //   border-color: #FB5A4A;
      // }
    }
}
</style>
